import { useQuery } from '@tanstack/react-query'
import { apiSdk } from '../../api'

export const getPaymentMethodsQuery = (checkoutSession: string, publicApiKey: string) => ({
  queryKey: ['payment-methods'],
  queryFn: () => apiSdk.getPaymentMethods(checkoutSession, publicApiKey),
})

export const useGetPaymentMethods = (checkoutSession: string, publicApiKey: string) =>
  useQuery(getPaymentMethodsQuery(checkoutSession, publicApiKey))
